import React from "react";

import { HubTableHeader, InputLabel } from "../../components";

const required = true;

const headCells = [
  {
    id: "status",
    label: "Status",
  },
  {
    id: "employee",
    label: "Employee",
    required,
  },
  {
    id: "completed",
    label: "Completed",
    required,
  },
  {
    id: "scrapped",
    label: "Scrapped",
    required,
  },
  {
    id: "startDate",
    label: "Start Date",
    required,
  },
  {
    id: "endDate",
    label: "End Date",
    required,
  },
  {
    id: "heatCode",
    label: "Heat Code",
  },
  {
    id: "notes",
    label: "Notes",
  },
];

export const LaborTableHeader = ({
  showHeatCode = true,
  showContextMenuColumn = true,
}) => {
  const filteredCells = showHeatCode
    ? headCells
    : headCells.filter((cell) => cell.id !== "heatCode");
  const ITEMS = filteredCells.map((cell) => ({
    id: cell.id,
    label: cell?.required ? (
      <InputLabel label={cell.label} required disableMargin />
    ) : (
      cell.label
    ),
  }));
  return (
    <HubTableHeader
      items={ITEMS}
      includeCheckbox={false}
      includeEnd={showContextMenuColumn}
      sx={{ backgroundColor: "hubColors.greyLighter" }}
    />
  );
};

export default LaborTableHeader;
